export default "/images/vendor/@coreui/icons/svg/flag/cif-br.svg?f7c0560658c5fd7a335e9f80977a6472";